import { Box, Button, FormControl, Text } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { useContext } from 'react'

import { FormLabel } from '../components/FormLabel'
import { InputGroup } from '../components/InputGroup'
import { Save } from '../icons'
import { insuranceParamsContext } from '../layouts/Wizard'
import { insurerOfferContext } from './hoc/WithOffer'

interface AddVehicleInfoFormProps {
  onSubmit: (values: AddVehicleInfoFormValues) => Promise<any>
}

export interface AddVehicleInfoFormValues {
  vin: string
  registration?: string
  tpNumber?: string
  orvNumber?: string
}

export const AddVehicleInfoForm = ({ onSubmit }: AddVehicleInfoFormProps) => {

  const { insuranceParams } = useContext(insuranceParamsContext)
  const vehicle = (insuranceParams as InsuranceParamsDto).vehicle
  const methods = useForm<AddVehicleInfoFormValues>({
    defaultValues: {
      vin: vehicle.vin ?? undefined,
      registration: vehicle.licensePlate ?? undefined,
      tpNumber: vehicle.cisloTechnickehoPrukazu ?? undefined,
      orvNumber: vehicle.cisloOrv ?? undefined
    },
  })

  const { handleSubmit, register, formState } = methods
  const { errors, isSubmitting } = formState

  const handleFormSubmit = (values: AddVehicleInfoFormValues) => onSubmit(values)

  const { isLoading: isLoadingOffer, offer } = useContext(insurerOfferContext)
  const isUniqa = (offer?.insurerId ?? 0) === 1
  const orvDisabled = false

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Box sx={{ display: 'grid', gap: 4, justifyItems: 'start' }}>
          <FormControl>
            <FormLabel htmlFor="vin">VIN</FormLabel>

            <InputGroup
              id="vin"
              htmlSize={18}
              errors={errors.vin}
              {...register('vin')}
              isDisabled
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="registration">Registrační značka (SPZ)</FormLabel>

            <InputGroup
              id="registration"
              htmlSize={6}
              errors={errors.registration}
              {...register('registration')}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="tpNumber">Číslo velkého technického průkazu</FormLabel>

            <InputGroup
              id="tpNumber"
              htmlSize={6}
              errors={errors.tpNumber}
              {...register('tpNumber')}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="orvNumber">Číslo ORV</FormLabel>

            <InputGroup
              id="orvNumber"
              htmlSize={7}
              errors={errors.orvNumber}
              isDisabled={orvDisabled}
              {...register('orvNumber')}
            />
          </FormControl>

          {!isUniqa &&
            <Button
              type="submit"
              variant="solid"
              colorScheme="primary"
              isLoading={isSubmitting}
              isDisabled={isSubmitting}
            >
              <Save />
              Uložit
            </Button>
          }

          {isUniqa &&
            <Box>
              <Text variant='error'>
                Doplnění údajů nelze nyní touto cestou provést. Změny je nutné provést po zaplacení smlouvy přímo v portálu UNIQA (IVOS) - https://ivos.uniqa.cz/prod
              </Text>
            </Box>
          }

        </Box>
      </form>
    </FormProvider>
  )
}
